import { EngagementRequest } from '@pages/talent-finder/models/request/engagement-request.interface';
import { EngagementsFilterRequest } from '@pages/talent-finder/models/engagements/engagements-filter-request.interface';

const actionScope = '[Engagements]';

export class CreateEngagement {
  static readonly type = `${actionScope} Create Engagement`;
  constructor(public engagement: EngagementRequest) {}
}

export class EditEngagement {
  static readonly type = `${actionScope} Edit Engagement`;
  constructor(
    public id: string,
    public engagement: EngagementRequest
  ) {}
}

export class CreateEngagementCompleted {
  static readonly type = `${actionScope} Create Engagement Completed`;
}

export class LoadHasAnyEngagements {
  static readonly type = `${actionScope} Load Has Any Engagements`;
}

export class LoadEngagementLookups {
  static readonly type = `${actionScope} Load Engagement Lookups`;
}

export class LoadEngagements {
  static readonly type = `${actionScope} Load Engagements`;
  constructor(public engagementsFilterRequest: EngagementsFilterRequest) {}
}

export class LoadEngagement {
  static readonly type = `${actionScope} Load Engagement`;
  constructor(public id: string) {}
}

export class CloseEngagement {
  static readonly type = `${actionScope} Close Engagement`;
  constructor(public id: string) {}
}

export class DeleteEngagement {
  static readonly type = `${actionScope} Delete Engagement`;
  constructor(public id: string) {}
}
